export const formStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const saveButtonContentStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
};

export const partnerMessageWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const partnerMessageHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '8px',
};

export const helperTextStyles = {
  marginTop: '4px',
};
